import { ENVIRONMENT } from "../../../utils/Constants";
import { Environment, ExpertRole } from "../../../utils/Enums";

interface EnvironmentIndicatorProps {
    role: ExpertRole | null;
    className?: string;
}

export const EnvironmentIndicator: React.FC<EnvironmentIndicatorProps> = ({ role, className = "" }) => {
    if (!role) return null;

    const bgColor = role === ExpertRole.Admin ? "bg-holifya-red" : "bg-holifya-blue";

    // Development environment indicator for all
    if (ENVIRONMENT === Environment.DEVELOP) {
        return (
            <div className={`text-white text-xs ${bgColor} px-2 py-1 rounded-br-md shadow-md ${className}`}>
                {role.toUpperCase()}
            </div>
        );
    }

    return null;
}; 